import { createSlice } from '@reduxjs/toolkit';
import { allSites } from '../../utils/Level/utils';

const initialState = {
  level1: [],
  level2: [],
  level3: [],
  allLevel: [],
  account: {
    allLevelAccounts: [[], [], []],
    allSites: allSites,
    voucherCurrentIndex: 2,
  },
};

export const levelSlice = createSlice({
  name: 'accountLevels',
  initialState,
  reducers: {
    setLevel1: (state, action) => {
      console.log('asdkfjkhkajh flasd ', action.payload);
      state.level1 = action.payload;
    },
    setLevel2: (state, action) => {
      state.level2 = action.payload;
    },
    setLevel3: (state, action) => {
      state.level3 = action.payload;
    },
    setAllLevel: (state, action) => {
      state.allLevel = action.payload;
    },
    setAccount: (state, action) => {
      state.account = action.payload;
    },
    resetLevel1: state => {
      state.level1 = this.level1;
    },
    resetLevel2: state => {
      state.level2 = this.level2;
    },
    resetLevel3: state => {
      state.level3 = this.level3;
    },
    resetAllLevel: state => {
      state.allLevel = this.allLevel;
    },
    resetAccount: state => {
      state.account = this.account;
    },
  },
});

export const {
  setLevel1,
  setLevel2,
  setLevel3,
  setAllLevel,
  setAccount,
  resetLevel1,
  resetLevel2,
  resetLevel3,
  resetAllLevel,
  resetAccount,
} = levelSlice.actions;

export const openingBalance = state => state.accountLevels.level3;
export const accountsData = state => state.accountLevels.allLevel;
export const level1Data = state => state.accountLevels.level1;
export const level2Data = state => state.accountLevels.level2;
export const level3Data = state => state.accountLevels.level3;

export default levelSlice.reducer;
